import React from "react";

import RFID from "./RFID";
import Lock from "./Lock";
import ExitButton from "./ExitButton";
import DoorSensor from "./DoorSensor";
import AlarmOut from "./AlarmOut";
import Block from "./Block";
import BlockTurnstile from "./BlockTurnstile";
import EmergencyOpen from "./EmergencyOpen";
import EntryButton from "./EntryButton";
import EntryRelay from "./EntryRelay";
import ExitRelay from "./ExitRelay";
import FACE from "./FACE";
import FINGER from "./FINGER";
import FireAlarmIn from "./FireAlarmIn";
import KEYPAD from "./KEYPAD";
import LoopSensor from "./LoopSensor";
import OpenButton from "./OpenButton";
import OpenRelay from "./OpenRelay";
import PassControl from "./PassControl";

const components = {
    RFID,
    Lock,
    ExitButton,
    DoorSensor,
    AlarmOut,
    Block,
    EmergencyOpen,
    EntryButton,
    EntryRelay,
    ExitRelay,
    FACE,
    FINGER,
    FireAlarmIn,
    KEYPAD,
    LoopSensor,
    OpenButton,
    OpenRelay,
    PassControl,

};

const ComponentWrapper = ({ name, ...props }) => {
    const ComponentToRender = components[name];
    if (!ComponentToRender) {
        return <div>Component not found.</div>;
    }

    return <ComponentToRender {...props} />;
};

export default ComponentWrapper;
